import React, { Component } from 'react';

import logo from '../../../assets/img/nave-black-new-logo.svg';
import boardLimit from '../../../assets/img/board-limit.svg'
// Import Style
import '../style.scss';

class NotFoundPage extends Component {
  render() {
    return (
      <div className='downtime'>
        <div className='top_header downtime_header'>
          <a href='/'><img alt="logo" src={logo} /></a>
        </div>

        <div className='downtime_wrap'>
          <div className='downtime_content'>
            <h1>Page Not Found</h1>
            <p> I'm sorry, the page you were <br/>looking for cannot be found!</p>
            <a className='btn btn-primary' href="/" id="loginBtn">
              Let's Try That Again
            </a>
          </div>
          
          <div className='downtime_icon'>
            <img alt="downtime icon" src={boardLimit}/>
          </div>
        </div>
      </div>
    );
  }
}
export default NotFoundPage;
